/* eslint-disable redux-saga/no-unhandled-errors */
import { all, put, call, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import {
  accessToSampleRequest,
  deleteSubscriptionRequest,
  fetchProvidersMappingRequest,
  fetchSubscriptionsRequest,
  checkIfTableIsInConnectionRequest,
  setIsTableInConnectionStatus,
  setProviders,
  setSamples,
  setSubscribingError,
  setSubscribingStatus,
  setSubscriptions,
  setSubscriptionsStatus,
  setSubscritionsError,
  subscribeToPublicDatasetRequest
} from './dataObservatorySlice'
import { SpatialExtensionProps, TableConnectionProp } from '../types'
import {
  deleteSubscription,
  getSamplesDatasets,
  getSubscriptionsDatasetsWithSpatialIndex,
  searchDOTableInConnection,
  subscribePublicData,
  subscribeSample
} from '../api/dataObservatory'
import { ApiError, RequestStatus } from 'features/common'
import { getProvidersMapping } from 'features/data-observatory/api/dataObservatory'

function* checkIfTableIsInConnection(action: PayloadAction<TableConnectionProp>) {
  yield put(setIsTableInConnectionStatus(RequestStatus.Pending))
  const result = yield call(searchDOTableInConnection, action.payload)
  if (result === false) {
    yield put(setIsTableInConnectionStatus(RequestStatus.Rejected))
  } else {
    yield put(setIsTableInConnectionStatus(RequestStatus.Fulfilled))
  }
}

function* fetchSubscriptions(action: PayloadAction<SpatialExtensionProps & { connection: string }>) {
  try {
    const getSubscriptionDatasetsFn = getSubscriptionsDatasetsWithSpatialIndex
    yield put(setSubscriptionsStatus(RequestStatus.Pending))
    const [samples, subscriptions] = yield all([
      call(getSamplesDatasets, action.payload),
      call(getSubscriptionDatasetsFn, action.payload)
    ])
    yield put(setSamples(samples.rows))
    yield put(setSubscriptions(subscriptions.rows))
    yield put(setSubscriptionsStatus(RequestStatus.Fulfilled))
  } catch (e) {
    yield put(setSubscriptionsStatus(RequestStatus.Rejected))
    yield put(setSubscritionsError(e as ApiError))
  }
}

function* fetchProviders() {
  try {
    const providers = yield call(getProvidersMapping)
    yield put(setProviders(providers))
  } catch (e) {
    // TODO
  }
}

function* removeSubscriptionRequest(action: PayloadAction<string>) {
  try {
    yield call(subscribeWrapper, function* cb() {
      yield call(deleteSubscription, action.payload)
    })
  } catch (e) {
    yield put(setSubscribingStatus(RequestStatus.Rejected))
    yield put(setSubscribingError(e as ApiError))
  }
}

function* subscribePublicDataset(action: PayloadAction<string>) {
  try {
    yield call(subscribeWrapper, function* cb() {
      yield call(subscribePublicData, action.payload)
    })
  } catch (e) {
    yield put(setSubscribingStatus(RequestStatus.Rejected))
    yield put(setSubscribingError(e as ApiError))
  }
}

function* accessToSample(action: PayloadAction<string>) {
  try {
    yield call(subscribeWrapper, function* cb() {
      yield call(subscribeSample, action.payload)
    })
  } catch (e) {
    yield put(setSubscribingStatus(RequestStatus.Rejected))
    yield put(setSubscribingError(e as ApiError))
  }
}

function* subscribeWrapper(callback) {
  yield put(setSubscribingStatus(RequestStatus.Pending))
  yield call(callback)
  yield put(setSubscribingStatus(RequestStatus.Fulfilled))
  yield put(setSubscribingStatus(RequestStatus.Idle))
  yield put(setSubscriptionsStatus(RequestStatus.Idle))
}

function* watchFetchDataExplorer() {
  yield takeLatest(fetchSubscriptionsRequest.type, fetchSubscriptions)
  yield takeLatest(fetchProvidersMappingRequest.type, fetchProviders)
  yield takeLatest(accessToSampleRequest.type, accessToSample)
  yield takeLatest(subscribeToPublicDatasetRequest.type, subscribePublicDataset)
  yield takeLatest(deleteSubscriptionRequest.type, removeSubscriptionRequest)
  yield takeLatest(checkIfTableIsInConnectionRequest.type, checkIfTableIsInConnection)
}

export default function* dataExplorerSagas() {
  try {
    yield all([watchFetchDataExplorer()])
  } catch (e) {
    //TODO
  }
}
